import { getUserInfo } from '@api/userInfo';
export default {
    state: {
        userInfo: {}
    },
    mutations: {
        SET_USERINFO(state, data) {
            state.userInfo = data;
        }
    },
    actions: {
        async queryUserInfo({ commit }) {
            const { code, data, msg } = await getUserInfo();
            const userInfo = data;
            if (code === 0) {
                commit('SET_USERINFO', userInfo);
            } else {
                return Promise.reject(new Error(msg));
            }
        }
    }
};
